import * as THREE from 'three';
import Experience from '../Experience.js';
import vertexShader from '../shaders/portalFlowGrill/vertex.glsl';
import fragmentShader from '../shaders/portalFlowGrill/fragment.glsl';
import retroVertexShader from '../shaders/retroShader/vertex.glsl';
import retroFragmentShader from '../shaders/retroShader/fragment.glsl';
import matrixVertexShader from '../shaders/matrixScreen/vertex.glsl';
import matrixFragmentShader from '../shaders/matrixScreen/fragment.glsl';
import laptopVertexShader from '../shaders/laptopScreen/vertex.glsl';
import laptopFragmentShader from '../shaders/laptopScreen/fragment.glsl';
import gsap from 'gsap';

export default class Dungeon {
  constructor(_options) {
    this.experience = new Experience();
    this.config = this.experience.config;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.scene = this.experience.scene;
    this.debug = this.experience.debug;

    this.allProjects = document.querySelectorAll('.allProjects');
    this.prevProjectButtons = document.querySelectorAll('.prevButton');
    this.nextProjectButtons = document.querySelectorAll('.nextButton');

    // console.log(this.experience.camera);
    if (this.debug) {
      this.debugFolder = this.debug.addFolder({
        title: 'factory'
      });
    }

    this.currrentIcon = 0;
    this.currentProject = 0;

    this.width = 479;
    this.height = 800;
    this.ratio = this.width / this.height;
    this.count = this.width * this.height;
    this.group = new THREE.Group();
    this.scene.add(this.group);

    this.setMaterials();
    this.setGeometry();
    this.backed();
    this.setAnims();
    this.setButtons();
  }
  setMaterials() {
    this.anmisScene = this.resources.items.animsModel.scene;
    // console.log(this.anmisScene);
    // console.log(this.resources.items.animsModel);

    //all the animations for the icons

    //all the skills icon texture for the screen material map
    this.iconScreen = [
      this.resources.items.blenderIconTexture,
      this.resources.items.cssIconTexture,
      this.resources.items.htmlIconTexture,
      this.resources.items.javascriptIconTexture,
      this.resources.items.githubIconTexture,
      this.resources.items.npmIconTexture,
      this.resources.items.threeIconTexture,
      this.resources.items.reactIconTexture,
      this.resources.items.figmaIconTexture
    ];
    //same settings for the textures
    this.iconScreen.forEach((screen) => {
      screen.flipY = false;
      screen.encoding = THREE.sRGBEncoding;
    });

    //matCaps
    this.silverMatCapMaterial = new THREE.MeshMatcapMaterial({
      matcap: this.resources.items.silverMatCap,
      flatShading: true
    });
    this.blueMatCapMaterial = new THREE.MeshMatcapMaterial({
      matcap: this.resources.items.blueMatCap,
      flatShading: true
    });
    this.blackMatCapMaterial = new THREE.MeshMatcapMaterial({
      matcap: this.resources.items.blackMatCap,
      flatShading: true
    });
    this.yellowColorMaterial = new THREE.MeshBasicMaterial({
      color: '#C6C552'
    });

    this.redColorMaterial = new THREE.MeshBasicMaterial({
      color: '#CC0000'
    });

    //backedMats
    this.resources.items.bakedFactory.flipY = false;
    this.resources.items.bakedFactory.encoding = THREE.sRGBEncoding;
    this.bakedFactoryMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.bakedFactory
    });

    this.resources.items.mobileIconsBake.flipY = false;
    this.resources.items.mobileIconsBake.encoding = THREE.sRGBEncoding;
    this.mobileIconsBakeMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.mobileIconsBake
    });

    this.resources.items.bakedFloor.flipY = false;
    this.resources.items.bakedFloor.encoding = THREE.sRGBEncoding;
    this.bakedFloorMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.bakedFloor
    });

    this.resources.items.factoryOutsideWalls.flipY = false;
    this.resources.items.factoryOutsideWalls.encoding = THREE.sRGBEncoding;
    this.factoryOutsideWalls = new THREE.MeshBasicMaterial({
      map: this.resources.items.factoryOutsideWalls
    });

    this.resources.items.bakedSign.flipY = false;
    this.resources.items.bakedSign.encoding = THREE.sRGBEncoding;
    this.signMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.bakedSign
    });

    this.resources.items.logo.flipY = false;
    this.resources.items.logo.encoding = THREE.sRGBEncoding;
    this.logoMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.logo
    });

    this.cableMat = new THREE.ShaderMaterial({
      fragmentShader,
      vertexShader,
      uniforms: {
        uTime: { value: 0 },
        uRoughness: { value: this.resources.items.testnoise }
      }
    });

    //mesh and materials for non baked geometry
    this.resources.items.cantine.flipY = false;
    this.resources.items.cantine.encoding = THREE.sRGBEncoding;

    this.resources.items.daPortal.flipY = false;
    this.resources.items.daPortal.encoding = THREE.sRGBEncoding;

    this.resources.items.scrimba.flipY = false;
    this.resources.items.scrimba.encoding = THREE.sRGBEncoding;

    this.matrixMaterial = new THREE.ShaderMaterial({
      fragmentShader: matrixFragmentShader,
      vertexShader: matrixVertexShader,
      uniforms: {
        uTime: { value: 0 }
      }
    });

    this.resources.items.laptopMask.flipY = false;
    this.resources.items.laptopMask.encoding = THREE.sRGBEncoding;
    this.laptopMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.laptopMask
    });
    this.project1Material = new THREE.ShaderMaterial({
      fragmentShader: retroFragmentShader,
      vertexShader: retroVertexShader,
      uniforms: {
        uTime: { value: 0 },
        vignetteOpacity: { value: 0.8 },
        vignetteRoundness: { value: 0.2 },
        brightness: { value: 1.1 },
        textureSampler: { value: this.resources.items.cantine },
        curvature: { value: new THREE.Vector2(5, 5) },
        screenResolution: { value: new THREE.Vector2(200, 200) },
        scanLineOpacity: { value: new THREE.Vector2(0.1, 0.1) }
      }
    });
    this.project2Material = new THREE.ShaderMaterial({
      fragmentShader: retroFragmentShader,
      vertexShader: retroVertexShader,
      uniforms: {
        uTime: { value: 0 },
        vignetteOpacity: { value: 0.8 },
        vignetteRoundness: { value: 0.2 },
        brightness: { value: 1.1 },
        textureSampler: { value: this.resources.items.daPortal },
        curvature: { value: new THREE.Vector2(5, 5) },
        screenResolution: { value: new THREE.Vector2(200, 200) },
        scanLineOpacity: { value: new THREE.Vector2(0.1, 0.1) }
      }
    });
    this.project3Material = new THREE.ShaderMaterial({
      fragmentShader: retroFragmentShader,
      vertexShader: retroVertexShader,
      uniforms: {
        uTime: { value: 0 },
        vignetteOpacity: { value: 0.8 },
        vignetteRoundness: { value: 0.2 },
        brightness: { value: 1.1 },
        textureSampler: { value: this.resources.items.scrimba },
        curvature: { value: new THREE.Vector2(5, 5) },
        screenResolution: { value: new THREE.Vector2(200, 200) },
        scanLineOpacity: { value: new THREE.Vector2(0.1, 0.1) }
      }
    });
    this.projectsMachineMaterial = new THREE.ShaderMaterial({
      fragmentShader: laptopFragmentShader,
      vertexShader: laptopVertexShader,
      side: THREE.DoubleSide,
      uniforms: {
        uTime: { value: 0 },
        iResolution: { value: new THREE.Vector2(1.7, 1.8) },
        fragCoord: { value: new THREE.Vector2(1, 1) }
      }
    });

    //icons materials

    this.resources.items.blenderBake.flipY = false;
    this.resources.items.blenderBake.encoding = THREE.sRGBEncoding;
    this.blenderMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.blenderBake
    });

    this.resources.items.htmlbake.flipY = false;
    this.resources.items.htmlbake.encoding = THREE.sRGBEncoding;
    this.htmlMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.htmlbake
    });
    this.resources.items.cssBake.flipY = false;
    this.resources.items.cssBake.encoding = THREE.sRGBEncoding;
    this.cssMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.cssBake
    });

    this.resources.items.figmaBake.flipY = false;
    this.resources.items.figmaBake.encoding = THREE.sRGBEncoding;
    this.figmaMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.figmaBake
    });

    this.resources.items.jsBake.flipY = false;
    this.resources.items.jsBake.encoding = THREE.sRGBEncoding;
    this.jsMaterial = new THREE.MeshBasicMaterial({
      map: this.resources.items.jsBake
    });
  }
  setGeometry() {
    this.fans = this.anmisScene.children.filter(
      (child) => child.type === 'Object3D' && child.name !== 'signEmpty'
    );

    this.trail = this.anmisScene.children.find(
      (child) => child.name === 'trail'
    );

    this.projectsStructure = this.anmisScene.children.find(
      (child) => child.name === 'projects'
    );
    this.projectsStructure.material = this.blueMatCapMaterial;

    this.project1 = this.anmisScene.children.find(
      (child) => child.name === 'project1'
    );
    this.project2 = this.anmisScene.children.find(
      (child) => child.name === 'project2'
    );
    this.project3 = this.anmisScene.children.find(
      (child) => child.name === 'project3'
    );

    this.projectScreen = this.anmisScene.children.find(
      (child) => child.name === 'projectPanelScreen'
    );

    this.codeToSkillScreen = this.anmisScene.children.find(
      (child) => child.name === 'codeToSkillScreen'
    );
    this.laptopScreen = this.anmisScene.children.find(
      (child) => child.name === 'laptopScreen'
    );

    this.skillsScreen = this.anmisScene.children.find(
      (child) => child.name === 'skillsScreen'
    );
    this.skillsScreen.material = new THREE.MeshBasicMaterial({
      map: this.iconScreen[0]
    });

    this.projectGroup = new THREE.Group();

    this.projectGroup.add(
      this.projectsStructure,
      this.project1,
      this.project2,
      this.project3
    );

    // console.log(this.projectGroup);
    this.projectGroup.position.set(
      10.625626564025879,
      1.5330958366394043,
      -6.699931621551514
    );
    this.projectsStructure.position.set(0, -2.08, 0);
    this.project1.position.set(0, -2.08, 0);
    this.project2.position.set(0, -2.08, 0);
    this.project3.position.set(0, -2.08, 0);
    // console.log(this.project1);
    this.project1.material = this.project1Material;
    // this.project1.material = this.project1Material;
    this.project2.material = this.project2Material;
    this.project3.material = this.project3Material;

    //screens
    this.projectScreen.material = this.projectsMachineMaterial;
    // this.projectScreen.material = this.whiteColorMaterial;
    this.codeToSkillScreen.material = this.matrixMaterial;
    this.laptopScreen.material = this.laptopMaterial;

    this.trail.material = this.silverMatCapMaterial;
    this.trail.material.morphTargets = true;

    for (const group of this.fans) {
      for (const child of group.children) {
        child.material = this.silverMatCapMaterial;
      }
    }

    if (this.debug) {
      this.debugFolder.addInput(this.projectGroup.rotation, 'y', {
        step: 0.01,
        min: -7,
        max: 7
      });
      // .on('change', () =>
      // {
      //     this.color.instance.set(this.color.value)
      // })
    }

    this.group.add(this.projectGroup);
    this.group.add(this.anmisScene);
  }
  backed() {
    this.scene = this.resources.items.dungeonModel.scene;
    // console.log(this.scene);

    //get geometries
    this.bakedFactory = this.scene.children.find(
      (child) => child.name === 'Cylinder'
    );
    this.floor = this.scene.children.find((child) => child.name === 'floor');
    this.outsideWalls = this.scene.children.find(
      (child) => child.name === 'outside-walls'
    );
    this.cableSmall = this.scene.children.find(
      (child) => child.name === 'cableSmall'
    );
    this.cableBig = this.scene.children.find(
      (child) => child.name === 'cableBig'
    );

    this.handleDoor1 = this.anmisScene.children.find(
      (child) => child.name === 'holeDoorRight'
    );
    this.handleDoor1in = this.anmisScene.children.find(
      (child) => child.name === 'holeDoorRight001'
    );
    this.handleDoor2 = this.anmisScene.children.find(
      (child) => child.name === 'holeDoorLeft'
    );
    this.handleDoor2in = this.anmisScene.children.find(
      (child) => child.name === 'holeDoorLeft001'
    );
    this.mobileIcons = this.scene.children.find(
      (child) => child.name === 'icon-mobile'
    );

    // getting icon geometries

    // blender
    this.blenderIcon = this.scene.children.find(
      (child) => child.name === 'blender001'
    );

    this.blenderAnimated = this.anmisScene.children.find(
      (child) => child.name === 'blender002'
    );
    // html
    this.htmlIcon = this.scene.children.find(
      (child) => child.name === 'html5003'
    );

    this.htmlAnimated = this.anmisScene.children.find(
      (child) => child.name === 'html5004'
    );
    // npm
    this.npmIcon = this.scene.children.find((child) => child.name === 'npm003');

    this.npmAnimated = this.anmisScene.children.find(
      (child) => child.name === 'npm004'
    );

    // three
    this.threeIcon = this.scene.children.find(
      (child) => child.name === 'threejs003'
    );

    this.threeAnimated = this.anmisScene.children.find(
      (child) => child.name === 'threejs004'
    );

    // css
    this.cssIcon = this.scene.children.find(
      (child) => child.name === 'css3003'
    );

    this.cssAnimated = this.anmisScene.children.find(
      (child) => child.name === 'css3004'
    );

    // git
    this.githubIcon = this.scene.children.find(
      (child) => child.name === 'github003'
    );

    this.githubAnimated = this.anmisScene.children.find(
      (child) => child.name === 'github004'
    );
    //

    // js
    this.jsIcon = this.scene.children.find((child) => child.name === 'js003');

    this.jsAnimated = this.anmisScene.children.find(
      (child) => child.name === 'js004'
    );
    //
    // react
    this.reactIcon = this.scene.children.find(
      (child) => child.name === 'Torus001'
    );

    this.reactAnimated = this.anmisScene.children.find(
      (child) => child.name === 'react002'
    );
    //
    // figma
    this.figmaIcon = this.scene.children.find(
      (child) => child.name === 'figma002'
    );

    this.figmaAnimated = this.anmisScene.children.find(
      (child) => child.name === 'figma003'
    );
    //

    this.sign = this.anmisScene.children.find(
      (child) => child.name === 'signEmpty001'
    );

    this.lever = this.anmisScene.children.find(
      (child) => child.name === 'lever'
    );
    //get materials

    //assing materials
    this.bakedFactory.material = this.bakedFactoryMaterial;
    this.floor.material = this.bakedFloorMaterial;
    this.outsideWalls.material = this.factoryOutsideWalls;
    this.sign.children[0].material = this.signMaterial;
    this.sign.children[1].material = this.logoMaterial;

    this.mobileIcons.material = this.mobileIconsBakeMaterial;

    this.blenderIcon.material = this.blenderMaterial;
    this.blenderAnimated.material = this.blenderMaterial;

    this.htmlIcon.material = this.htmlMaterial;
    this.htmlAnimated.material = this.htmlMaterial;

    this.npmIcon.material = this.blackMatCapMaterial;
    this.npmAnimated.material = this.blackMatCapMaterial;

    this.threeIcon.material = this.blackMatCapMaterial;
    this.threeAnimated.material = this.blackMatCapMaterial;

    this.githubIcon.material = this.blackMatCapMaterial;
    this.githubAnimated.material = this.blackMatCapMaterial;

    this.reactIcon.material = this.blueMatCapMaterial;
    this.reactAnimated.material = this.blueMatCapMaterial;

    this.cssIcon.material = this.cssMaterial;
    this.cssAnimated.material = this.cssMaterial;

    this.figmaIcon.material = this.figmaMaterial;
    this.figmaAnimated.material = this.figmaMaterial;

    this.jsIcon.material = this.jsMaterial;
    this.jsAnimated.material = this.jsMaterial;

    this.handleDoor1.material = this.blueMatCapMaterial;
    this.handleDoor2.material = this.blueMatCapMaterial;
    this.handleDoor1in.material = this.yellowColorMaterial;
    this.handleDoor2in.material = this.yellowColorMaterial;
    this.lever.material = this.redColorMaterial;

    //set the shaders material for the cable pulse energy   search for better solution than current

    this.cableBig.material = this.cableMat;
    this.cableSmall.material = this.cableMat;

    //add to group
    this.group.add(this.scene);
  }
  setAnims() {
    this.iconsAnims = this.resources.items.animsModel.animations.slice(0, 9);
    //create 2 mixers 1 for loop and 1 for the on call animation

    this.mixer = new THREE.AnimationMixer(this.anmisScene);
    this.iconMixer = new THREE.AnimationMixer(this.anmisScene);

    this.clips = this.resources.items.animsModel.animations;

    // console.log(this.clips);

    this.loopClips = [
      this.clips[22],
      this.clips[35],
      this.clips[42],
      this.clips[49],
      this.clips[56],
      this.clips[63], // all the empties above for fans and sign motion
      this.clips[16], // lever working on icon machine
      this.clips[15], //trail
      this.clips[11] //code icon falling
    ];

    this.loopClips.forEach((clip) => {
      this.mixer.clipAction(clip).reset().play();
    });

    this.playNext(this.currrentIcon);
  }

  playNext(num) {
    this.skillsScreen.material.map = this.iconScreen[this.currrentIcon];
    this.skillsScreen.material.needsUpdate = true;

    //will make this conditional when we start the modes

    if (this.experience.camera.logic.mode === 'menu') {
      this.nextProject();
    }

    this.iconMixer.stopAllAction();
    this.iconMixer.clipAction(this.iconsAnims[num]).reset().play();
    this.iconMixer.clipAction(this.clips[12]).reset().play();
    this.iconMixer.clipAction(this.clips[13]).reset().play();
    this.iconMixer.clipAction(this.clips[20]).reset().play();
    this.iconMixer.clipAction(this.clips[21]).reset().play();
    setTimeout(() => {
      this.startTimer();
    }, 5500);
  }
  // , //doors opening
  //     this.clips[15], //doors opening
  //     this.clips[24],
  //     this.clips[25]

  nextProject() {
    if (this.experience.camera.logic.buttonsLocked === false) {
      let nextProject = this.currentProject + 1;
      if (nextProject > 2) {
        this.currentProject = 0;
      } else {
        this.currentProject = nextProject;
      }
      this.setProjectVisibility();
      this.experience.camera.logic.lockButtons(1000);
      gsap.to(this.projectGroup.rotation, {
        y: this.projectGroup.rotation.y + (Math.PI * 2) / 3,
        duration: 1
      });
    }
  }
  prevProject() {
    if (this.experience.camera.logic.buttonsLocked === false) {
      let nextProject = this.currentProject - 1;
      if (nextProject < 0) {
        this.currentProject = 2;
      } else {
        this.currentProject = nextProject;
      }
      this.setProjectVisibility();
      this.experience.camera.logic.lockButtons(1000);
      gsap.to(this.projectGroup.rotation, {
        y: this.projectGroup.rotation.y - (Math.PI * 2) / 3,
        duration: 1
      });
    }
  }
  setProjectVisibility() {
    if (this.experience.camera.logic.mode === 'projects') {
      this.removeProjectVisibility();
      this.allProjects[this.currentProject].classList.add('active');
    }
  }
  removeProjectVisibility() {
    this.allProjects.forEach((project) => {
      project.classList.remove('active');
    });
  }
  startTimer() {
    let nextAction = this.currrentIcon + 1;
    this.currrentIcon =
      nextAction > this.iconsAnims.length - 1 ? 0 : this.currrentIcon + 1;
    this.playNext(this.currrentIcon);
  }
  setButtons() {
    this.nextProjectButtons.forEach((button) =>
      button.addEventListener('click', () => this.nextProject())
    );
    this.prevProjectButtons.forEach((button) =>
      button.addEventListener('click', () => this.prevProject())
    );
  }
  update() {
    //    this.material.uniforms.iTime.value = this.time.elapsed * 0.001
    if (this.cableMat)
      this.cableMat.uniforms.uTime.value = this.time.elapsed * 0.15;
    if (this.matrixMaterial)
      this.matrixMaterial.uniforms.uTime.value = this.time.elapsed * 0.001;
    if (this.projectsMachineMaterial)
      this.projectsMachineMaterial.uniforms.uTime.value =
        this.time.elapsed * 0.001;
    if (this.project1Mat) this.project1Mat.update();
    if (this.project2Mat) this.project2Mat.update();
    if (this.project3Mat) this.project3Mat.update();

    if (this.mixer) this.mixer.update(this.time.delta * 0.0008);
    if (this.iconMixer) this.iconMixer.update(this.time.delta * 0.0008);
  }
}
